import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-bar',
  standalone: true,
  host: { class: 'block shrink-0' },
  imports: [RouterLink],
  templateUrl: './app-bar.component.html',
})
export class AppBarComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private msal = inject(MsalService);

  breadcrumbs = signal<Breadcrumb[]>([]);

  get currentUserName(): string {
    const account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];
    return account?.name ?? account?.username ?? '';
  }

  ngOnInit() {
    this.buildBreadcrumbs();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.buildBreadcrumbs());
  }

  goBack() {
    const crumbs = this.breadcrumbs();
    if (crumbs.length > 1) {
      this.router.navigateByUrl(crumbs[crumbs.length - 2].url);
    }
  }

  private buildBreadcrumbs() {
    const crumbs: Breadcrumb[] = [];
    let currentRoute = this.route.root;
    let url = '';

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const snapshot = currentRoute.snapshot;

      if (snapshot.url.length) {
        url += '/' + snapshot.url.map(s => s.path).join('/');
        const label: string | undefined = snapshot.data['breadcrumb'];
        if (label) crumbs.push({ label, url });
      }
    }

    this.breadcrumbs.set(crumbs);
  }
}
